import { ReactFlowProvider } from '@xyflow/react'
import { useMemo } from 'react'

import BpmnFlowCanvas from './BpmnFlowCanvas'
import { BpmnDiagramContext } from './bpmn-diagram.context'
import { BpmnDiagramProps } from './bpmn-diagram.types'
import { SequenceDocumentationContext } from './sequence-documentation.context'

export default function BpmnDiagram(props: BpmnDiagramProps) {
  const callbacks = useMemo(
    () => ({
      onNodesPositionChanged: props.onNodesPositionChanged,
      onNodesSwimlaneChanged: props.onNodesSwimlaneChanged,
      onNodesDragging: props.onNodesDragging,
      onBoundaryEventPositionChanged: props.onBoundaryEventPositionChanged,
      onOpenConfigPanel: props.onOpenConfigPanel,
      onNodeRightClick: props.onNodeRightClick,
      onSequenceClick: props.onSequenceClick,
      onCanvasInteraction: props.onCanvasInteraction,
      onViewportChange: props.onViewportChange,
      onPaneClicked: props.onPaneClicked,
      onSwimlaneRightClick: props.onSwimlaneRightClick,
      onMultiSelection: props.onMultiSelection,
      onMultiSelectionCleared: props.onMultiSelectionCleared,
      onSwimlaneResize: props.onSwimlaneResize,
      onNavAreaClick: props.onNavAreaClick,
      onConfirmAreaRemoval: props.onConfirmAreaRemoval,
      onRenameNode: props.onRenameNode,
      onShowSubprocessesMenu: props.onShowSubprocessesMenu,
      onPaletteDrop: props.onPaletteDrop,
      onNodeDrop: props.onNodeDrop,
      onDropError: props.onDropError,
      onSequenceDrop: props.onSequenceDrop,
      onSequenceSegmentMoved: props.onSequenceSegmentMoved,
      onSequencesChanged: props.onSequencesChanged,
      onSequenceCreate: props.onSequenceCreate,
      onNodeCreateWithSequence: props.onNodeCreateWithSequence,
      onSwimlaneAdd: props.onSwimlaneAdd,
      onSwimlaneMove: props.onSwimlaneMove,
      onSwimlaneDelete: props.onSwimlaneDelete,
      onSwimlaneDocumentation: props.onSwimlaneDocumentation,
      onSwimlaneRename: props.onSwimlaneRename,
      onConfirmAutoArrange: props.onConfirmAutoArrange,
      onPlanAutoLayout: props.onPlanAutoLayout,
      onAutoLayoutApplied: props.onAutoLayoutApplied,
      onLayoutPreviewChange: props.onLayoutPreviewChange,
    }),
    [
      props.onNodesPositionChanged,
      props.onNodesSwimlaneChanged,
      props.onNodesDragging,
      props.onBoundaryEventPositionChanged,
      props.onOpenConfigPanel,
      props.onNodeRightClick,
      props.onSequenceClick,
      props.onCanvasInteraction,
      props.onViewportChange,
      props.onPaneClicked,
      props.onSwimlaneRightClick,
      props.onMultiSelection,
      props.onMultiSelectionCleared,
      props.onSwimlaneResize,
      props.onNavAreaClick,
      props.onConfirmAreaRemoval,
      props.onRenameNode,
      props.onShowSubprocessesMenu,
      props.onPaletteDrop,
      props.onNodeDrop,
      props.onDropError,
      props.onSequenceDrop,
      props.onSequenceSegmentMoved,
      props.onSequencesChanged,
      props.onSequenceCreate,
      props.onNodeCreateWithSequence,
      props.onSwimlaneAdd,
      props.onSwimlaneMove,
      props.onSwimlaneDelete,
      props.onSwimlaneDocumentation,
      props.onSwimlaneRename,
      props.onConfirmAutoArrange,
      props.onPlanAutoLayout,
      props.onAutoLayoutApplied,
      props.onLayoutPreviewChange,
    ]
  )

  return (
    <ReactFlowProvider>
      <BpmnDiagramContext.Provider value={callbacks}>
        <SequenceDocumentationContext.Provider value={props.sequenceDocumentation ?? null}>
          <BpmnFlowCanvas {...props} />
        </SequenceDocumentationContext.Provider>
      </BpmnDiagramContext.Provider>
    </ReactFlowProvider>
  )
}
